/* eslint-disable @typescript-eslint/prefer-optional-chain */
/* eslint-disable import/no-extraneous-dependencies */

export async function getHealthDetailsCompDynamically(healthInputOpen, setHealthDynamicWidget, isFloatingWidget) {
  if (healthInputOpen || isFloatingWidget) {
    try {
      // Dynamically import the module
      const dynamicImports = await import(
        '@acko-tech/health-retail-components.health-retail-components.sem-input-details'
      )

      // Ensure the Overlay component is correctly exported from the module
      if (dynamicImports && dynamicImports.Overlay) {
        // Set the Overlay component in the state or wherever you need it
        setHealthDynamicWidget({
          Overlay: dynamicImports.Overlay,
        })
      } else {
        // Handle the case where Overlay is not available
        console.error('Overlay component not found in dynamic import.')
      }
    } catch (error) {
      // Handle any errors that may occur during dynamic import
      console.error('Error while dynamically importing the module:', error)
    }
  }
}
